<template>
    <div style="min-width: 100%;">
        <div v-if="order">
            <div>
                <prop name="Best.">{{ order.number }}</prop>
            </div>
            <div>
                <prop name="Res.">{{ order.reservation.startTime | shortDateTime }}</prop>
            </div>
            <div class="mt-3">
                <div>Reservierung suchen, die bestehende ersetzen soll:</div>
                <search type="reservation" @select="newReservation = $event"/>
            </div>
            <div v-if="newReservation">
                {{ newReservation.number }}
            </div>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="cancelOldReservationCheck"
                       v-model="cancelOldReservation">
                <label class="form-check-label" for="cancelOldReservationCheck">
                    alte Reservierung stornieren
                </label>
            </div>
            <div class="mt-3 text-right">
                <button class="btn btn-danger btn-sm" @click="$emit('cancel')">Abbrechen</button>
                <button class="btn btn-success btn-sm" @click="save" :disable="readyToSubmit">Speichern</button>
            </div>
        </div>
        <div v-else>
            keine Bestellung ausgewählt
        </div>
    </div>
</template>

<script>
import Search from "../search/Search.vue";
import prop from "../../layouts/Prop.vue";

export default {
    name: "SwitchReservation.vue",
    components: {Search, prop},
    props: {
        orderId: String
    },
    data() {
        return {
            order: null,
            newReservation: null,
            cancelOldReservation: true
        }
    },
    computed: {
        readyToSubmit() {
            return this.order && this.newReservation
        }
    },
    methods: {
        async loadOrder() {
            console.log('loading order ...')
            this.order = await this.$api.get(`/orders/${this.orderId}`)
                .then(res => res.data)
                .catch(err => this.handleError(err))
                .finally(() => console.log('...done loading order.'))
            console.log('loaded order: ' + this.order.id)
        },
        async save() {
            await this.$api.put(`/orders/${this.orderId}/reservation/${this.newReservation.id}`,
                {},
                {
                    params: {
                        cancelOldReservation: this.cancelOldReservation
                    }
                }).then(() => {
                this.showInfo("Die Reservierung für die Bestellung wurde geändert.")
                this.$router.go(0)
            })
                .catch(err => this.handleError(err))
                .finally(() => console.log('...done loading order.'))
        }
    },
    watch: {
        orderId: {
            handler(newVal, oldVal) {
                if (newVal && newVal !== oldVal)
                    this.loadOrder()
            }
            ,
            immediate: true
        }
    }
}
</script>

<style scoped>

</style>
